import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminHeader } from './AdminHeader';
import { AdminSidebar } from './AdminSidebar';
import { useUI } from '@shared/hooks/useUI';

/**
 * Admin Layout Component
 * Integrates AdminHeader and AdminSidebar with proper content spacing.
 * Pixel-perfect parity with Angular .main-content and body styles.
 */
export const AdminLayout = () => {
    const { sidebarOpen, toggleSidebar, setSidebarOpen } = useUI();

    useEffect(() => {
        // Ensure sidebar is closed on mobile on initial mount
        if (window.innerWidth < 1024) {
            setSidebarOpen(false);
        }
    }, []); // Only run once on mount

    return (
        <div className={`admin-layout min-h-screen bg-gray-50 dark:bg-[#0a0e19] ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            {/* Sidebar */}
            <AdminSidebar />

            {/* Sidebar Backdrop for Mobile */}
            {sidebarOpen && (
                <div
                    className="sidebar-backdrop"
                    onClick={toggleSidebar}
                    aria-hidden="true"
                />
            )}

            {/* Main Content Wrapper */}
            <AdminHeader />

            <div className="main-content min-h-screen flex flex-col">
                {/* Main Content Area */}
                <main className="flex-1 pb-10">
                    <div className="container-fluid">
                        <Outlet />
                    </div>
                </main>

                {/* Footer parity */}
                <footer className="py-6 px-4 md:px-8 border-t border-gray-100 dark:border-[#172036] bg-white dark:bg-[#0c1427] text-center">
                    <p className="text-sm text-gray-500 dark:text-gray-400">
                        © {new Date().getFullYear()} <span className="text-[#fd5812] font-bold">BenavidezBoxing</span>. All Rights Reserved.
                    </p>
                </footer>
            </div>
        </div>
    );
};

export default AdminLayout;
